import { render } from "./phone.vue?vue&type=template&id=091bcd4c&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"

import "./phone.vue?vue&type=style&index=0&id=091bcd4c&lang=css"
import "./phone.vue?vue&type=style&index=1&id=091bcd4c&lang=stylus&scoped=true"
import "./phone.vue?vue&type=style&index=2&id=091bcd4c&lang=stylus&scoped=true"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091bcd4c"]])

export default __exports__